import React, {Component} from "react";
import {observer} from "mobx-react";
import {Web3Store} from "../stores/web3Store";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {RootStore} from "../stores/rootStore";
import empty from "../images/empty.png";
import {Button, Tabs} from "antd";
import {MythActionType} from "../constant/MythAction";
import {IMythServerResponse, IPagination, IPRsp} from "../bean/ResponseBean";
import ActiveIPList from "../components/activeIPList";
import "../styles/userCenter.less"
import {MythServerResultCode} from "../constant/CommonConstant";
import logger from "../logger";
import {NoConnectedWallet} from "../components/noConnected/noConnectedWallet";

interface IProps extends RouteComponentProps {
    web3Store: Web3Store;
    rootStore: RootStore;
}

interface IStates {
    goldenAmount: number,
    classicAmount: number,
    issueNft: any,
    activeIPList: IPRsp[],
    licenseNFTList: IPRsp[],
    userId: number,
    loading: boolean
}

@observer
class UserCenter extends Component<IProps, IStates> {
    private firstRequest: boolean = true;

    constructor(props: IProps, state: IStates) {
        super(props);
        let locationState: any = this.props.location.state;
        this.state = {
            userId: locationState && locationState.ipId ? locationState.ipId : 0,
            goldenAmount: 0,
            classicAmount: 0,
            issueNft: null,
            activeIPList: [],
            licenseNFTList: [],
            loading: true
        }
    }

    passButton = (type: number) => {
        let amount: number = 0;
        const { goldenAmount, classicAmount } = this.state;
        if (type === MythActionType.TYPE_GOLDEN) {
            amount = goldenAmount;
        } else {
            amount = classicAmount
        }
        return <div className="text-center user-button-container">
            <Button className="myth-button" disabled={amount <= 0}>Amount {amount}</Button>
        </div>
    };

    getMyActivatedIPs = async () => {
        const { web3Store } = this.props;
        try {
            if (web3Store.mythServerApi && web3Store.account) {
                const result: IMythServerResponse<IPagination<IPRsp>> = await web3Store.mythServerApi.getMyActivatedIPs(web3Store.account);
                if (result.resultCode === MythServerResultCode.SUCCESS) {
                    const data = result.resultValue;
                    if (data) {
                        this.setState({
                            activeIPList: data.dataList,
                            loading: false
                        });
                    }
                }
            }
        } catch (e) {
            logger.error(e);
        }
    };

    getPassNum = async () => {
        const { web3Store } = this.props;

        try {
            if (web3Store.mythGraphApi && web3Store.account) {
                this.firstRequest = false;
                const mythPasses = await web3Store.mythGraphApi.fetchMythPass(web3Store.account);
                this.setState({
                    goldenAmount: mythPasses.goldenPassTokenIds.length,
                    classicAmount: mythPasses.classicPassTokenIds.length
                }, () => {
                    this.getMyActivatedIPs();
                });
            }
        } catch (e) {
            logger.error(e);
        }
    };

    render() {
        const { web3Store } = this.props;
        const { activeIPList, loading } = this.state;
        if (this.firstRequest) {
            this.getPassNum();
        }
        const { TabPane } = Tabs;

        return <div className="user-page-container">
            <div className="flex-row top-content">
{/*                <div className="user-pass flex-col">
                    <div className="list-title">My PASS</div>
                    <div className="myth-panel">
                        <ShadowPASSCard
                            goldenContent={this.passButton(MythActionType.TYPE_GOLDEN)}
                            classicContent={this.passButton(MythActionType.TYPE_CLASSIC)}
                        />
                    </div>
                </div>*/}
                <div className="user-issue flex-col">
                    <div className="list-title">Launch and manage IP-licensed NFT</div>
                    <div className="myth-panel flex-col space-between">
                        <div className="image-box">
                            <img src={empty} alt="" className="issue-img" />
                        </div>
                        <div className="text-center user-button-container"><Button className="myth-button"
                            disabled>SOON</Button></div>
                    </div>
                </div>
            </div>
            <Tabs defaultActiveKey="1" className="myth-tabs">
                <TabPane tab="Licensed IP" key="1">
                    {
                        web3Store.account ?
                            <ActiveIPList list={activeIPList} loading={loading} /> :
                            <NoConnectedWallet web3Store={web3Store} />
                    }
                </TabPane>
                {/* <TabPane tab="License NFT" key="2">
                    License NFT
                </TabPane>
                <TabPane tab="My collection card" key="3">
                    My collection card
                </TabPane>*/}
            </Tabs>
        </div>
    }
}

export default withRouter(UserCenter);
